export default [
  {
    id: '101',
    labelEn: 'rankingTeam',
    sortValue: 101,
    path: '/management/ranking-team',
    name: '首页',
    component: 'Layout',
    meta: {
      title: '首页',
      icon: '',
      breadcrumb: true,
      affix: false,
      hideBreadcrumb: false,
      carryParam: false,
      hideTab: false,
      hideMenu: false
    },
    resources: [
      {
        id: '10101',
        createTime: '2021-12-01 00:00:00',
        createdBy: '1',
        updateTime: '2021-12-02 00:00:00',
        updatedBy: '1',
        code: 'manage:rankingTeam:view',
        name: '查看',
        nameEn: 'view',
        menuId: '101',
        describe: '',
        readonly: true
      }
    ],
    alwaysShow: false
  },
  {
    id: '102',
    labelEn: 'rankingTeamHistory',
    sortValue: 102,
    path: '/management/ranking-team-history',
    name: '排队历史',
    component: 'Layout',
    meta: {
      title: '排队历史',
      icon: '',
      breadcrumb: true,
      affix: false,
      hideBreadcrumb: false,
      carryParam: false,
      hideTab: false,
      hideMenu: false
    },
    resources: [
      {
        id: '10201',
        createTime: '2021-12-01 00:00:00',
        createdBy: '1',
        updateTime: '2021-12-02 00:00:00',
        updatedBy: '1',
        code: 'manage:rankingTeamHis:view:view',
        name: '查看',
        nameEn: 'view',
        menuId: '102',
        describe: '',
        readonly: true
      }
    ],
    alwaysShow: false
  }
]
